'use strict';

import React from 'react';
import { Route, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Attempts from '../Attempts'; 
import AttemptForm from '../AttemptForm'; 
import ServeForm from '../ServeForm'; 
import BadAddressForm from '../BadAddressForm';

export default class Page extends React.Component {

	constructor() {

		super();

		this.state = {
			mode: 'select'
		};

		[
			'setModeServe',
			'setModeAttempt',
			'setModeBadAddress'
		].forEach(fn => { this[fn] = this[fn].bind(this) });
	}

	setModeServe() {
		this.setState({ mode: 'serve' });
	}

	setModeAttempt() {
		this.setState({ mode: 'attempt' });
	}

	setModeBadAddress() {
		this.setState({ mode: 'badAddress' });
	}

	componentDidUpdate(prevState) {
		const { jobId } = this.props;

		if (jobId !== prevState.jobId) {
			this.setState({ mode: 'select' });
		}
	}

	render() {

		const { mode } = this.state;

		return (
			<div>
				{ mode === 'select' &&
					<div className='actionTabs'>
						<button
							onClick={ this.setModeAttempt }
							className='attempt'
						>
							<span className='icon'>
								<FontAwesomeIcon icon='home' color='#444'/>
							</span>
							<span className='txt'>Attempt</span>
						</button>
						<button
							onClick={ this.setModeServe }
							className='serve'
						>
							<span className='icon'>
								<FontAwesomeIcon icon='check' color='#fff'/>
							</span>
							<span className='txt'>Serve</span>
						</button>
						<button
							onClick={ this.setModeBadAddress }
							className='badAddress'
						>
							<span className='icon'>
								<FontAwesomeIcon icon='ban' color='#fff'/>
							</span>
							<span className='txt'>Bad Address</span>
						</button>
					</div>
				}
				{ mode === 'attempt' &&
					<AttemptForm />
				}
				{ mode === 'serve' &&
					<ServeForm  />
				}
				{ mode === 'badAddress' &&
					<BadAddressForm />
				}
				{ (mode === 'attempt' || mode === 'select') &&
					<Attempts />
				}
			</div>
		);
	}
}
